import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';

import { Routes } from '../../../Routes';
import { Link } from '../..';
import Social from './Social';

export const DesktopFooter = (): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);

  return (
    <div className='container'>
      <div className='hidden lg:flex mb-4'>
        <div className='flex-auto space-x-3'>
          <Link to={Routes.public.trust} newTab externalUS>
            {t('components.footer.trustAndSafety')}
          </Link>
          <Link to={Routes.public.giftCards} newTab externalUS>
            {t('components.footer.giftCards')}
          </Link>
          <Link to={Routes.support} newTab externalUS>{t('components.footer.support')}</Link>
          <Link to={Routes.public.aboutUs} newTab externalUS>
            {t('components.footer.aboutUs')}
          </Link>
          <Link to={Routes.public.privacyPolicy} newTab externalUS>
            {t('components.footer.privacy')}
          </Link>
          <Link to={Routes.public.terms} newTab externalUS>
            {t('components.footer.terms')}
          </Link>
          <Link to={Routes.public.careers} newTab externalUS>
            {t('components.footer.careers')}
          </Link>
          <Link to='https://blog.urbansitter.com/child-care-resources-for-parents/' newTab externalUS>
            {t('components.footer.resources')}
          </Link>
        </div>
        <div className='flex-auto text-left mt-4 lg:text-right lg:mt-0'>
          <span className='mr-2 hidden lg:inline'>{t('components.footer.followUs')}</span>
          <Social />
        </div>
      </div>
      <div className='hidden lg:block'>
        <span>&copy; {t('components.footer.copyright')}</span>
      </div>
    </div>
  );
};
